import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import defined from '~app/core/defined';
import { patchLinks } from '~app/core/patchLinks';

import PerfectScrollbarContainer from './PerfectScrollbarContainer';

class RawHtml extends Component {

  componentDidUpdate() {
    if (defined(this.scrollContainer)) {
      this.scrollContainer.scrollTop = 0;
    }
  }

  render() {
    return (
      <PerfectScrollbarContainer
        ref={(elem) => this.scrollContainer = elem}
      >
        <div
          ref={(elem) => patchLinks(elem)}
          className={classNames("RawHtml", {
            [`RawHtml--${this.props.styleName}`]: defined(this.props.styleName),
          })}
          dangerouslySetInnerHTML={{
            __html: this.props.htmlContent,
          }}
        />
      </PerfectScrollbarContainer>
    );
  }
}

RawHtml.propTypes = {
  htmlContent: PropTypes.string.isRequired,
  styleName: PropTypes.string,
};

export default RawHtml;



// WEBPACK FOOTER //
// ./src/components/RawHtml.js